<template>
  <div class="custom-wrapper" :class="{active: visible || visible2 || visible3}">
    <div class="position: relative;">
      <!-- .custom-text-type-1 === ctt1 -->
      <popper :show-popper="visible" @close="visible=false" placement="right-start" :index="index">
        <div class="ctt1" @click.prevent="setVisible()">
          <div class="ctt1-box custom-item">
            <!-- 内容 -->
            <!-- product-group  .pg -->
            <div class="pg">
              <div class="pg-title" v-if="formInline.ShowGroupName">{{formInline.Name || '商品分组'}}</div>
              <div class="pg-content">
                <img src="@assets/img/template/company-component-cove-10-1.jpg" v-if="formInline.ListStyle === '大图'" />
                <img src="@assets/img/template/company-component-cove-10-2.jpg" v-if="formInline.ListStyle === '小图'" />
                <img src="@assets/img/template/company-component-cove-10-3.jpg" v-if="formInline.ListStyle === '一大两小'" />
                <img src="@assets/img/template/company-component-cove-10-4.jpg" v-if="formInline.ListStyle === '详细列表'" />
              </div>
            </div>
            <!-- 关闭按钮 -->
            <i class="icon iconfont icon-close-c custom-close" @click="close()"></i>
          </div>
        </div>
        <div slot="content" class="ctt1-poptip">
          <!-- 设置内容 -->
          <div class="ctt1p-content">
            <!-- <div style="word-break: break-all;white-space: pre-wrap;">{{JSON.stringify(formInline)}}</div> -->
            <Form ref="formInline" :model="formInline" :label-width="100"> 
              <FormItem label="分组名称:">
                <Input
                  style="width:300px"
                  type="textarea"
                  v-model="formInline.Name"
                  placeholder="请输入分组名称"
                />
                <div style="padding-top: 15px;">
                  <Checkbox v-model="formInline.ShowGroupName">
                    <span class="pt5">页面上显示商品分组名称</span>
                  </Checkbox>
                </div>
              </FormItem>
              <FormItem label="第一优先级:">
                <Select v-model="formInline.FirstPriority" style="width:300px" placeholder="请选择">
                  <Option
                    v-for="item in firstPriorityList"
                    :value="item.value"
                    :key="item.value"
                  >{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="第二优先级:">
                <Select v-model="formInline.SecondPriority" style="width:300px" placeholder="请选择">
                  <Option
                    v-for="item in secondPriorityList"
                    :value="item.value"
                    :key="item.value"
                  >{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="列表样式:">
                <RadioGroup v-model="formInline.ListStyle" type="button">
                  <Radio label="大图"></Radio>
                  <Radio label="小图"></Radio>
                  <Radio label="一大两小"></Radio>
                  <Radio label="详细列表"></Radio>
                </RadioGroup>
                <div style="padding-top: 15px;">
                  <!-- <Checkbox v-model="formInline.ShowProductName" @on-change="productNameChange"> -->
                  <Checkbox v-model="formInline.ShowProductName">
                    <span class="pt5">显示商品名称</span>
                  </Checkbox>
                </div>
                <!-- <div style="padding-top: 15px;">
                  <Checkbox v-model="formInline.ShowProductPrice">
                    <span class="pt5">显示商品价格</span>
                  </Checkbox>
                </div> -->
              </FormItem>
              <!-- <FormItem label="分组简介:">
                <Input
                  style="width:300px"
                  type="textarea"
                  v-model="formInline.Introduction"
                  placeholder="请输入分组简介"
                />
              </FormItem>-->
            </Form>
          </div>

          <!-- <a @click="visible=false">关闭</a> -->
        </div>
      </popper>
      <!-- 上方增加键 -->
      <Poptip
        v-model="visible2"
        placement="right-start"
        width="411"
        class="custom-add-wrapper z-top"
        v-if="false"
      >
        <img src="@/assets/img/custom/add.png" />
        <div slot="content" class="ctt1-poptip">
          <div class="ct-components">
            <div class="ctc-title">新增组件</div>
            <div class="ctc-group">
              <div
                class="ctc-item"
                v-for="(item, index) in commmonArr"
                :key="'commmon-' + index"
                @click="add(item, 'top')"
              >
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
      </Poptip>
      <!-- 下方增加键 -->
      <Poptip
        v-model="visible3"
        placement="right-start"
        width="411"
        class="custom-add-wrapper z-bottom"
      >
        <img src="@/assets/img/custom/add.png" />
        <div slot="content" class="ctt1-poptip">
          <div class="ct-components">
            <div class="ctc-title">新增组件</div>
            <div class="ctc-group">
              <div
                class="ctc-item"
                v-for="(item, index) in commmonArr"
                :key="'commmon-' + index"
                @click="add(item, 'bottom')"
              >
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
      </Poptip>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import popper from "@components/vue-popper/VuePopper.vue";

export default {
  // 产品类型 1
  name: "custom-product-type-1",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() {
        return {
          type: 1,
          Name: "", // 分组名称
          ShowGroupName: 1, // 显示分组名称
          FirstPriority: 1, // 第一显示优先级
          SecondPriority: 2, // 第二显示优先级
          ListStyle: 1, // 列表样式
          ShowProductName: 1, // 显示产品的名称
          ShowProductPrice: 1, // 显示产品的价格
          Introduction: "" // 分组的描述
        };
      }
    }
  },
  data() {
    return {
      firstPriorityList: [
        {
          value: "0",
          label: "显示顺序越小越靠前"
        },
        {
          value: "1",
          label: "最热的排再前面"
        }
      ],
      secondPriorityList: [
        {
          value: "0",
          label: "显示顺序越小靠前"
        },
        {
          value: "1",
          label: "创建时间越晚越靠前"
        },
        {
          value: "2",
          label: "创建时间越早越靠前"
        }
      ],
      ListStyleArr: ["大图", "小图", "一大两小", "详细列表"],
      visible: true,
      visible2: false,
      visible3: false,

      commmonArr: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        },
        {
          title: "标题",
          icon: "icon-biaoti",
          type: "title",
          componentName: "customTitle",
          config: {
            type: 1, // 标题类型 暂时只有 1
            content: "",
            position: "left", // 文本对齐格式
            padding: "12px", // 标题的边距
            fontSize: "12px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色
            link: {
              type: "3",
              value: ""
            }
          }
        },
        {
          title: "链接",
          icon: "icon-link",
          type: "link",
          componentName: "customLink",
          config: [{
            type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
            name: "",
            url: ""
          }]
        },
        {
          title: "产品搜索",
          icon: "icon-sousuo",
          type: "search",
          componentName: "customSearch",
          config: {
            type: 1, // 搜索类型 暂时只有 1
            words: ["热词1", "热词2"],
            style: "circular", // 搜索外边框样式 （圆 \ 方）
            position: "left", // 文本对齐格式
            color: "#ccc",
            background: "#f5f5f5",
            borderColor: "#91c0ec"
          }
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        }
      ],
      commmonArr2: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left" // 文本对齐格式
          }
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: ""
                }
              }
            ]
          }
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0" // 视频封面累心 0 截取 1 自定义
          }
        }
      ],
      formInline: {
        Name: "", // 分组名称
        ShowGroupName: true, // 显示分组名称
        FirstPriority: "0", // 第一显示优先级
        SecondPriority: "0", // 第二显示优先级
        ListStyle: "小图", // 列表样式
        ShowProductName: true, // 显示产品的名称
        ShowProductPrice: true, // 显示产品的价格
        Introduction: "" // 分组的描述
      },
      editType: false // 是否是编辑 or 添加
    };
  },
  watch: {
    activeIndex(val, oldVal) { 
      if (val !== this.index) this.visible = false;
    },
    save(val, oldVal) {
      if (val) {
        this.handleSubmit();
        this.visible = false;
      }
    }
  },
  components: {
    popper
  },
  computed: {
    ...mapGetters({
      activeIndex: "customComponentModule/getActiveIndex",
      company: "loginModule/getCompany",
      save: "customComponentModule/getSave"
    })
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations({
      setActiveIndex: "customComponentModule/setActiveIndex"
    }),
    init() {
      if (this.Modal) {
        const m = this.Modal;
        this.formInline = {
          Name: m.Name, // 分组名称
          ShowGroupName: m.ShowGroupName ? true : false, // 显示分组名称
          FirstPriority: this.firstPriorityList[m.FirstPriority].value, // 第一显示优先级
          SecondPriority: this.secondPriorityList[m.SecondPriority].value, // 第二显示优先级
          ListStyle: this.ListStyleArr[m.ListStyle], // 列表样式
          ShowProductName: m.ShowProductName ? true : false, // 显示产品的名称
          ShowProductPrice: m.ShowProductPrice ? true : false, // 显示产品的价格
          Introduction: "" // 分组的描述
        }; 
      }
    },
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    popperHide() { 
    },
    add(item, index) {
      // top 表示在上面添加  bottom表示下面添加
      let idx = this.index;
      if (index === "bottom") {
        idx = this.index + 1;
      }
      this.$emit("add", item, idx);
      this.visible = false;
      this.visible2 = false;
      this.visible3 = false;
      
      
    },
    close() {
      this.$emit("close");
    },
    handleSubmit() { 
      const form = this.formInline;
      const req = {
        type: 1,
        Name: form.Name,
        ShowGroupName: form.ShowGroupName ? 1 : 0,
        FirstPriority: Number(form.FirstPriority),
        SecondPriority: Number(form.SecondPriority),
        ListStyle: this.ListStyleArr.indexOf(form.ListStyle),
        ShowProductName: form.ShowProductName ? 1 : 0,
        ShowProductPrice: form.ShowProductPrice ? 1 : 0,
        Introduction: this.Modal.Introduction
      };
      console.log(req);
      this.$emit("change", req);
      this.visible = false;
    },
    productNameChange(bool) { 
      if (!bool) {
        this.formInline.ShowProductPrice = bool;
      }
    }
  }
};
</script>

<style lang="scss">
.custom-wrapper {
  .ivu-select-dropdown {
    width: 300px;
    left: 0;
  }
}
</style>
<style scoped lang="scss">
.ctt1 {
  width: 100%;
  &-box {
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  &-poptip {
    min-height: 60px;
    .ctt1p {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-content {
        padding: 50px 50px 20px;
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}

.pt5 {
  padding-left: 5px;
  position: relative;
  top: 1px;
}
.pg {
  padding: 0 15px;
  &-title {
    padding: 15px 0;
    text-align: center;
    &::before,
    &::after {
      content: "";
      display: inline-block;
      width: 10px;
      height: 1px;
      background-color: #ccc;
      margin: 0 10px;
      position: relative;
      top: -4px;
    }
  }
  &-content {
    img {
      max-width: 100%;
    }
  }
}
.custom-add-wrapper.z-top {
  top: 3px;
}
.custom-add-wrapper.z-bottom {
  bottom: -6px;
}
.save-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
